import { render, staticRenderFns } from "./TypeRelease.vue?vue&type=template&id=6ac7c618&"
import script from "./TypeRelease.vue?vue&type=script&lang=js&"
export * from "./TypeRelease.vue?vue&type=script&lang=js&"
import style0 from "./TypeRelease.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports